import { EventBus } from '@/utils/eventBus'
import Kafka from '@/utils/kafka'
import { Logger } from '@/utils/logger'
import NotificationHelper from '@/utils/notificationHelper'
import { createPluginApp } from './plugin'

export const eventBus = new EventBus()

export const logger = new Logger('trace')

export const $app = createPluginApp(eventBus)

export const kafka = new Kafka({
  url: location.origin,
  path: '/socket.io',
  query: {},
  retryTimes: 50,
})

export const notificationHelper = new NotificationHelper()
